<div class="lang-menu" #menu>
  <button type="button" class="lang-trigger" [attr.aria-label]="'shared.language' | translate" [attr.aria-expanded]="isOpen()" (click)="toggle()" data-testid="public-lang-trigger">
    <app-icon name="globe" [size]="15" />
    {{ currentLocale.toUpperCase() }}
    <app-icon name="chevron-down" [size]="12" />
  </button>
  @if (isOpen()) {
    <div class="lang-panel">
      @for (loc of locales; track loc) {
        <button type="button" class="lang-option" [class.active]="loc === currentLocale" (click)="select(loc)">
          {{ loc.toUpperCase() }}
        </button>
      }
    </div>
  }
</div>
